import EmployeeConversions from "@/views/statistics/EmployeeConversions.vue";
import { USER_ROLES } from "@/mappings/user-roles";
import ExtendedReportPage from "@/views/statistics/ExtendedReport.vue";
import PostbacksList from "@/views/statistics/PostbacksList.vue";
import PostbackSingle from "@/views/statistics/PostbackSingle.vue";
import MarkingsList from "@/views/statistics/MarkingsList.vue";
import { NavigationGuardNext, Route } from "vue-router";
import ConversionSingle from "@/views/statistics/ConversionSingle.vue";
import EventTracerList from "@/views/statistics/EventTracerList.vue";
import EventTraceSingle from "@/views/statistics/EventTraceSingle.vue";

export default  [
    {
        path: 'event-tracer',
        name: 'event-tracer',
        component: EventTracerList,
        meta: {
            title: 'Event tracer',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'event/:id',
        name: 'event-trace',
        component: EventTraceSingle,
        meta: {
            title: 'Event trace',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'postbacks',
        name: 'postbacks',
        component: PostbacksList,
        props: (route: Route): any => ({ ...route.query }),
        meta: {
            title: 'Постбеки',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'postback/:id',
        name: 'postback',
        component: PostbackSingle,
        meta: {
            title: 'Постбек',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'conversions-report',
        name: 'conversions-report',
        component: EmployeeConversions,
        props: (route: Route): any => ({ ...route.query }),
        meta: {
            title: 'Конверсии',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'conversion/:id',
        name: 'conversion',
        component: ConversionSingle,
        meta: {
            title: 'Конверсия',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'extended-report/:favorite_id',
        name: 'extended-report',
        component: ExtendedReportPage,
        props: (route: Route): any => ({ ...route.query }),
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            if (!to.params.favorite_id) {
                to.params.favorite_id = 'nf';
            }

            next();
        },
        meta: {
            title: 'Расширенный отчет',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'extended-report/advertiser',
        name: 'extended-report-advertiser',
        component: ExtendedReportPage,
        props: (route: Route): any => ({ ...route.query }),
        meta: {
            title: 'Отчет по рекламодателям',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR,
            ],
        },
    },
    {
        path: 'price-marking-report',
        name: 'price-marking-report',
        component: MarkingsList,
        props: (route: Route): any => ({ ...route.query }),
        meta: {
            title: 'Отчёт по ценам и маркировке',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR,
            ],
        },
    },
];
